module.exports = __webpack_public_path__ + "img/3-3.0a02ff37.svg";